/* eslint-disable global-require */
import Background from 'assets/img/wic/Fruits_slides.jpg'
import React, { useRef } from 'react'
import { Card, CardHeader, Col, Container, Row } from 'reactstrap'
import aplssLogo from 'assets/img/wic/APLSS Logo Variants-02.png'

const Maintenance = () => {
  const fullPages = useRef(null)
  return (
    <div className="wrapper wrapper-full-page" ref={fullPages}>
      <div className="full-page section-image">
        <div className="maintenance-page">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto" lg="8" md="12">
                <Card className="card-login">
                  <CardHeader>
                    <h3 className="header text-center">
                      <img src={aplssLogo} alt="APLSS" width={'50%'} />
                    </h3>
                  </CardHeader>
                  <h2 className="text-center font-weight-bold mb-0">
                    APLSS is undergoing
                  </h2>
                  <h2 className="text-center font-weight-bold mt-0">
                    scheduled maintenance.
                  </h2>
                </Card>
              </Col>
            </Row>
          </Container>
          <div
            className="full-page-background"
            style={{
              backgroundImage: `url(${Background})`,
              opacity: 0.4,
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default Maintenance
